import {sentryAPIErrorV2} from './module_common';
import {dataContainerSelector} from './module_common_selector';

export const signInModalId = $(dataContainerSelector).data("signinmodal")
export const tryPremiumModalId = $(dataContainerSelector).data("trypremiummodal")

export function openModal(selector, functionName){
    const el = $(selector)
    if (el.length == 0){
        const contextData = {
            modalData:{
                function: functionName,
                selector: selector,
                uid: UIDg,
            }
        }
        const error = new Error('Error opening modal')
        error.name = selector+' modal open fail'
        sentryAPIErrorV2(error, contextData)
    }else{
        el.modal('show')
    }
}

export function openModalWithRef(selector, refElement, functionName){
    const el = $(selector)
    if (el.length == 0){
        const contextData = {
            modalData:{
                function: functionName,
                selector: selector,
                uid: UIDg,
            }
        }
        const error = new Error('Error opening modal')
        error.name = selector+' modal open fail'
        sentryAPIErrorV2(error, contextData)
    }else{
        el.modal('show', refElement)
    }
}